import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, resolveImg } from "../lib/api";

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center mb-12">
        <h1 className="font-serif font-bold text-4xl text-[#1C2B20]">Our Herbal Ranges</h1>
        <p className="mt-3 text-[#5A6B5D]">Browse every category of Ayurvedic goodness</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {categories.map((cat) => (
          <button
            key={cat.id}
            onClick={() => navigate(`/shop?category=${cat.id}`)}
            data-testid={`categories-page-${cat.id}`}
            className="group relative overflow-hidden rounded-3xl border border-[#E2DAD0] h-56 hover-lift text-left"
          >
            <img src={resolveImg(cat.image_url)} alt={cat.name} className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#13331D]/85 via-[#13331D]/20 to-transparent" />
            <div className="absolute bottom-0 left-0 p-6">
              <h3 className="font-serif text-2xl font-bold text-white">{cat.name}</h3>
              <span className="mt-2 inline-flex items-center gap-1.5 text-sm text-[#E7E1D3] font-medium">
                Explore <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Categories;
